// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3LSfN","empty":"ModalGraph_empty__2KlWV"};